/**
 * The main api service
 */
import http from '@util/http';
import { finance } from '@api/req';
import moment from 'moment';

// 设置目标收入保存
export async function querySetBudgetGroupAims(params) {
  return http.post(finance.BUDGET_GROUP_SET_AIMS, params);
}

// 目标收入历史信息
export async function queryBudgetGroupAims(params) {
  return http.get(finance.BUDGET_GROUP_GET_AIMS, params);
}

//* *******************预算调整*****************************
export async function queryAdjustBudgetMy(params) {
  return http.get(finance.BUDGET_GET_ADJUST_MY, params);
}

export async function queryAdjustBudgetWatch(params) {
  return http.get(finance.BUDGET_GET_ADJUST_WATCH, params);
}

export async function queryAdjustable(params) {
  return http.get(finance.BUDGET_GET_ADJUSTABLE, params);
} // 可调整金额
export async function queryBudgetAccount(params) {
  return http.get(finance.BUDGET_GET_ACCOUNT, params);
} // 余额明细
export async function queryAdjustmentWorkflow() {
  return http.get(finance.BUDGET_GET_ADJUSTMENT_WORKFLOW);
}

export async function queryAdjustmentInfo(params) {
  return http.get(finance.BUDGET_GET_ADJUSTMENT_INFO, params);
} // 编辑获得明细
export async function querySaveAdjustment(params) {
  return http.post(finance.BUDGET_ADJUSTMENT_SAVE, params);
} // 预算调整申请保存
export async function queryDownloadGroupSetTemplate() {
  http.download(finance.DOWNLOAD_GROUP_SET_TEMPLATE, {}, '预算设置模板.xlsx');
}

export async function queryDeleteAdjustment(params) {
  return http.get(finance.BUDGET_ADJUSTMENT_DELETE, params);
} // 删除申请
export async function queryNextAdjustment(params) {
  return http.get(finance.BUDGET_ADJUSTMENT_NEXT, params);
} // 流程审核
export async function queryReturnAdjustment(params) {
  return http.post(finance.BUDGET_ADJUSTMENT_RETURN, params);
} // 流程打回
export async function queryCallbackAdjustment(params) {
  return http.get(finance.BUDGET_ADJUSTMENT_CALLBACK, params);
} // 流程收回
//* *******************预算设置*****************************
export async function querySetBudgetMy(params) {
  return http.get(finance.BUDGET_GET_SET_MY, params);
}

export async function querySetBudgetWatch(params) {
  return http.get(finance.BUDGET_GET_SET_WATCH, params);
}

export async function queryBudgetSetWorkflow() {
  return http.get(finance.BUDGET_GET_SET_WORKFLOW);
} // 发起流程
export async function queryBudgetSetInfo(params) {
  return http.get(finance.BUDGET_GET_SET_INFO, params);
} // 编辑获得明细
export async function querySaveBudgetSet(params) {
  return http.post(finance.BUDGET_SET_SAVE, params);
} // 预算调整申请保存
export async function queryDeleteBudgetSet(params) {
  return http.get(finance.BUDGET_SET_DELETE, params);
} // 删除申请
export async function queryNextBudgetSet(params) {
  return http.get(finance.BUDGET_SET_NEXT, params);
} // 流程审核
export async function queryReturnBudgetSet(params) {
  return http.post(finance.BUDGET_SET_RETURN, params);
} // 流程打回
export async function queryCallbackBudgetSet(params) {
  return http.get(finance.BUDGET_SET_CALLBACK, params);
} // 流程收回

//* *******************收支分析*****************************
export async function queryBudgetAnalysis(params) {
  return http.get(finance.BUDGET_GET_ANALYSIS, params);
}

export async function queryBudgetAnalysisIncome(params) {
  return http.get(finance.BUDGET_GET_ANALYSIS_INCOME, params);
} // 收入分析明细

export async function queryExportBudgetAnalysisIncome(params) {
  return http.download(
    finance.BUDGET_GET_ANALYSIS_INCOME_EXPORT,
    params,
    `资金流水明细导出${moment().format('yyyyMMDDHHmmss')}.xlsx`,
  );
} // 收入分析明细导出

export async function queryBudgetAnalysisFunds(params) {
  return http.get(finance.BUDGET_GET_ANALYSIS_FUNDS, params);
} // 财务数据分析

export async function queryBudgetAnalysisFundsMonth(params) {
  return http.get(finance.BUDGET_GET_ANALYSIS_FUNDS_MONTH, params);
} // 财务数据分析月份

export async function queryBudgetAnalysisExpenditure(params) {
  return http.get(finance.BUDGET_GET_ANALYSIS_EXPENDITURE, params);
} // 支出分析明细
export async function queryExportBudgetAnalysisExpenditure(params) {
  return http.download(
    finance.BUDGET_GET_ANALYSIS_EXPENDITURE_EXPORT,
    params,
    `资金流水明细导出${moment().format('yyyyMMDDHHmmss')}.xlsx`,
  );
} // 支出分析明细导出

export async function queryBudgetAnalysisBudget(params) {
  return http.get(finance.BUDGET_GET_ANALYSIS_BUDGET, params);
} // 财务数据分析

export async function queryBudgetAnalysisBudgetMonth(params) {
  return http.get(finance.BUDGET_GET_ANALYSIS_BUDGET_MONTH, params);
} // 财务数据分析月份

export async function queryAnalysisBudgets(params) {
  return http.get(finance.BUDGET_GET_ANALYSIS_BUDGETS, params);
} // 收入分析预算统计
export async function queryAnalysisOperational(params) {
  return http.get(finance.BUDGET_GET_ANALYSIS_OPERATIONAL, params);
} // 收入分析运营报表
export async function queryAnalysisOperationalDetail(params) {
  return http.get(finance.BUDGET_GET_ANALYSIS_OPERATIONAL_DETAIL, params);
} // 收入分析运营报表详情
export async function queryAnalysisProfit(params) {
  return http.get(finance.BUDGET_GET_ANALYSIS_PROFIT, params);
} // 收入分析利润追踪
export async function queryAnalysisProfitDetail(params) {
  return http.get(finance.BUDGET_GET_ANALYSIS_PROFIT_DETAIL, params);
} // 收入分析利润追踪列表
/* -------------------------------------预算------------------------------------*/
/**
 * 获取预算组列表
 */
export async function queryBudgetGroupList(params) {
  return http.get(finance.BUDGET_GROUP_LIST, params);
}

export async function queryBudgetGroupMy(params) {
  return http.get(finance.BUDGET_GROUP_MY, params);
}

export async function queryBudgetGroupPerList(params) {
  return http.get(finance.BUDGET_GROUP_PER_LIST, params);
}

export async function queryEnableBudgetGroup(uuid) {
  return http.get(finance.BUDGET_GRUOP_ENABLE, { uuid });
}

export async function queryDisableBudgetGroup(uuid) {
  return http.get(finance.BUDGET_GRUOP_DISABLE, { uuid });
}

export async function queryEnableCapitalGroup(uuid) {
  return http.get(finance.CAPITAL_ENABLE, { uuid });
}

export async function queryDisableCapitalGroup(uuid) {
  return http.get(finance.CAPITAL_DISABLE, { uuid });
}

export async function queryBudgetGroupCandF(params) {
  return http.get(finance.BUDGET_GRUOP_GETCAF, params);
}

/**
 * 获取预算管理的总计
 */
export async function queryBudgetGroupSum(params) {
  return http.get(finance.BUDGET_GROUP_SUM, params);
}

/**
 * 获取预算组明细
 */
export async function queryBudgetGroupInfo(uuid) {
  return http.get(finance.BUDGET_GROUP_INFO, { uuid });
}

/**
 * 预算组保存
 */
export async function querySaveBudgetGroup(params) {
  return http.post(finance.BUDGET_GROUP_SAVE, params);
}

/**
 * 预算组设置列表
 */
export async function queryBudgetGroupSetList(params) {
  return http.get(finance.BUDGET_GROUP_SET_LIST, params);
}

/**
 * 添加预算组设置
 */
export async function querySaveBudgetGroupSet() {
  return http.get(finance.BUDGET_GROUP_SET_SAVE);
}

/**
 * 按季节导入预算设置
 */
export async function queryBatchImportBudgetGroupSet(params) {
  return http.post(finance.BUDGET_GROUP_SET_BATCHIMPORT, params);
}

/**
 * 预算组设置明细
 */
export async function queryImportBudgetGroupSetInfo(params) {
  return http.get(finance.BUDGET_GROUP_SET_DETAIL, params);
}

/**
 * 模板下载
 */
export async function queryTemplateImportBudgetGroupSet() {
  return http.get(finance.BUDGET_GROUP_SET_TEMPLATE);
}

/**
 * 预算流水列表
 */
export async function queryGroupRecordList(params) {
  return http.get(finance.BUDGET_GROUP_RECORD_LIST, params);
}

/**
 * 预算流水添加
 */
export async function queryAddGroupBookList(params) {
  return http.get(finance.BUDGET_GROUP_BOOK_LIST, params);
}

/**
 * 预算流水添加
 */
export async function queryAddGroupRecord(params) {
  return http.post(finance.BUDGET_GROUP_RECORD_ADD, params);
}

/**
 * 预算流水删除
 */
export async function queryDeleteGroupBook(params) {
  return http.post(finance.BUDGET_GROUP_RECORD_DELETE, params);
}

/**
 * 预算流水明细
 */
export async function queryGroupRecordInfo(uuid) {
  return http.get(finance.BUDGET_GROUP_RECORD_INFO, { uuid });
}

/**
 * 预算记录修改
 */
export async function queryUpdateGroupRecord(params) {
  return http.post(finance.BUDGET_GROUP_RECORD_UPDATE, params);
}

/**
 * 预算流水统计
 */
export async function queryBudgetStatistics(params) {
  return http.get(finance.BUDGET_RECORD_STATIS, params);
}

/**
 * 预算流水统计按月
 */
export async function queryBudgetStatisticsMonth(params) {
  return http.get(finance.BUDGET_RECORD_STATIS_MONTH, params);
}

/**
 * 预算流水分摊明细
 */
export async function queryBudgetApportionInfo(uuid) {
  return http.get(finance.BUDGET_APPORTION_LIST, { uuid });
}



// WEBPACK FOOTER //
// ./src/api/finance/budget.js